import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CookieService {

    public get(name: string): string | null {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    public set(name: string, value: string, days: number): void {
        const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `${ name }=${ encodeURIComponent(value) }; expires=${ expires }; path=/`;
    }

}
